@if (!(networkSyncService.isOnline$ | async) && sharedService.logged_in_user?.user_id) {
  <div style="position: fixed; top: 0; left: 0; right: 0; background: #b45309; color: #fff; text-align: center; padding: 2px 12px; font-size: 13px; display: flex; align-items: center; justify-content: center; gap: 8px; z-index: 9999;">
    <i class="fas fa-wifi-slash"></i>
    <strong>You are offline.</strong> Data shown may be cached. Changes will sync automatically when your connection is restored.
    @if (networkSyncService.pendingItemsCount$ | async; as count) {
      @if (count > 0) {
        <span
          style="background: rgba(0,0,0,0.25); border-radius: 4px; padding: 1px 8px; margin-left: 4px; cursor: pointer; text-decoration: underline;"
          (click)="openSyncQueueModal()"
          title="Click to view pending changes"
        >{{ count }} pending {{ count === 1 ? 'change' : 'changes' }}</span>
      }
    }
  </div>
}

<div class="app-shell row" [ngClass]="{'bg': isSidenavVisible}" style="height: 100vh; overflow-y: hidden; margin: 0;">

  @if (isSidenavVisible) {
    <div class="col-auto ps-0" style="padding-right: 0px">
      <app-sidenav></app-sidenav>
    </div>
  }
  <div class="col p-0 content-layout">
    <router-outlet></router-outlet>
    @if (isChatbotVisible) {
      <app-chatbot></app-chatbot>
    }
  </div>

</div>

@if ((sharedService.loading$ | async) && !(sharedService.kiosk_mode$ | async)) {
  <app-custom-spinner></app-custom-spinner>
}